import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import { useState } from "react";
import { updateUser, getUserAddressAdmin, getCompanies } from '../../utils/actions/allactions';
import { validateAdmin,getToken } from "../../utils/helper";
import PhoneInput from 'react-phone-number-input'
import AddressModal from "./AddressModal/AddressModal";
import { toast } from "react-toastify";
import useDocumentTitle from "../../utils/useDocumentTitle";

const EditUser = () => {
    const token = getToken();
    const navigate = useNavigate();
    useDocumentTitle('Edit Client User')
    let userToBeEdited = JSON.parse(localStorage.getItem("userToBeEdited"));
    const [phoneValue, setPhoneValue] = useState(userToBeEdited.phoneNumber);
    const [values, setValues] = useState({ ...userToBeEdited, companyName: userToBeEdited.companySiteId?.companyName });
    const [error, setError] = useState("");

    const [showAddressModal, setShowAddressModal] = useState(false);
    const [recentAddress, setRecentAddress] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState("");
    const [companies, setCompanies] = useState([]);
    const [companySites, setCompaniesSite] = useState([]);
    const [selectedUserCompany,setSelectedUserCompany] = useState('')

    let isActive = userToBeEdited.accountStatus === "Active" ? true : false;

    useEffect(() => {
        validateAdmin(token, navigate);
        fetchUserAddress();
        fetchCompanyDetails();
    }, []);

    const fetchUserAddress = async () => {
        let response = await getUserAddressAdmin(token, values._id);
        setValues({ ...values, address: response })
    }

    const validateUserValues = () => {
        if (!values.firstName ||
            !values.lastName ||
            !values.email ||
            !values.address.length > 0 ||
            !(values.companyName || selectedUserCompany) ||
            !values.userCompanySite
        ) {
            return false;
        }
        return true;
    }



    const handleEditUser = async () => {
        setError("")
        const isUserInputValid = validateUserValues();
        if (!isUserInputValid) {
            setError("Enter valid values for all the field")
        } else {
            const data = { ...values, phoneNumber: phoneValue||"",companyName:selectedUserCompany|| values.companyName }
            // console.log("data",data)
            const updatedUser = await updateUser(token, data);
            navigate('/admin/user-master');
            toast.success("User updated successfully")
        }
    }


    const handledAddAddress = (addressData) => {
        let addedAddress = values.address ? values.address : [];
        addedAddress.push(addressData)
        setValues({ ...values, address: addedAddress })
    }

    const handleAddressOnChange = (newFormData, index) => {
        let allAddresses = values.address ? values.address : [];
        let address = allAddresses[index];
        address = newFormData;
        allAddresses[index] = address;
        setValues({ ...values, address: allAddresses })
    }


    // Code for Address modal in Admin

    const deleteData = async (i) => {
        const updatedAddress = values.address;
        if (i > -1) {
            updatedAddress.splice(i, 1);
        }
        setValues({ ...values, address: updatedAddress })
    }

    const editHandler = (index) => {
        setShowAddressModal(true);
        setIsEdit(true)
        setEditId(index)
    }

    const openAddressModalHandler = () => {
        if (values.address?.length === 5) {
            toast.error('You can only add upto 5 Addresses');
            return;
        }
        setShowAddressModal(true);
    };

    const handleSiteSelect = (e) => {
        setValues({ ...values, userCompanySite: e.target.value })
    }

    const handleCompanySelect = (e) => {

        let selectedCompany = JSON.parse(e.target.value);
        setCompaniesSite(selectedCompany.companySite)
        setValues({ ...values, companyName: selectedCompany.companyName })
    }


    const fetchCompanyDetails = async () => {
        const fetchedCompanies = await getCompanies(token);
        let companyForEmail = fetchedCompanies.filter(isCompanyForEmail)
        setCompanies(companyForEmail);
        setCompaniesSite(companyForEmail[0]?.companySite);
        setCompanyToUser(companyForEmail[0]);
        if (companyForEmail.length < 1) {
            toast.error("Company does not exist for this domain. Please recheck email domain")
        }
    }

    const setCompanyToUser = (company) =>{
        setSelectedUserCompany(company?.companyName)
    }

    // console.log(values)

    const isCompanyForEmail = (company) => {
        const domain = values.email.split("@")[1];
        if (company.domain === domain) {
            return company
        }
    }



    return (
        <div  className="admin-container">
            {showAddressModal && (
                <AddressModal
                    addressModal={showAddressModal}
                    setShowAddressModal={setShowAddressModal}
                    setRecentAddress={setRecentAddress}
                    recentAddress={recentAddress}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    id={editId}
                    setValues={setValues}
                    values={values}
                    handledAddAddress={handledAddAddress}
                    handleAddressOnChange={handleAddressOnChange}
                />
            )}
            <div>
                <Sidebar />
            </div>
            <div className="admin-panel-container">
                <h1 className="center-heading text-xl font-bold my-2">  Edit User Details </h1>
                <div className="edit-company-container">
                    <div>
                        <label htmlFor="firstName" >First Name </label>: &nbsp;
                        <input
                            name="firstName"
                            type="text"
                            value={values.firstName}
                            onChange={(e) => { setValues({ ...values, firstName: e.target.value }) }}
                        />
                    </div>

                    <div>
                        <label htmlFor="lastName" >Last Name </label>: &nbsp;
                        <input
                            name="lastName"
                            type="text"
                            value={values.lastName}
                            onChange={(e) => { setValues({ ...values, lastName: e.target.value }) }}
                        />
                    </div>

                    <div>
                        <label htmlFor="email" >Email </label>: &nbsp;
                        <input
                            name="email"
                            type="text"
                            value={values.email}
                            onBlur={fetchCompanyDetails}
                            onChange={(e) => { setValues({ ...values, email: e.target.value }) }}
                        />
                    </div>

                    <div style={{ display: 'flex', width: '100%' }}>
                        <div>
                            <label htmlFor="phone" >Phone Number</label>: &nbsp;
                        </div>
                        <div style={{ width: '40%' }}>
                            <PhoneInput
                                placeholder="Enter phone number"
                                name="phone"
                                value={values.phoneNumber}
                                onKeyDown={(e) => ["e", "E", "-"].includes(e.key) && e.preventDefault()}
                                onChange={setPhoneValue}
                            />
                        </div>
                    </div>

                    {/* <div>
                        <label htmlFor="companyName" >Company Name </label>: &nbsp;
                        <input
                            name="companyName"
                            type="text"
                            value={values.companyName}
                            onChange={(e) => { setValues({ ...values, companyName: e.target.value }) }}
                        />
                    </div> */}

                    <div>
                        <label htmlFor="companyName" >Company Name </label>: &nbsp;
                        <select name='companyName' onChange={(e) => handleCompanySelect(e)}>
                            <option value="" disabled > Select Company</option>
                            {companies ? companies.map((company, i) => {
                                return <option key={i} value={JSON.stringify(company)} selected={values?.companySiteId?.companyName}>
                                    {company?.companyName}
                                </option>
                            }) : null
                            }
                        </select>
                    </div>

                    <div>
                        <label htmlFor="companySite" >Company Site </label>: &nbsp;
                        <select name='companySite' onChange={(e) => handleSiteSelect(e)}  value={values.userCompanySite}>
                            <option value="" selected disabled > Select Company Site</option>
                            {companySites ? companySites.map((companySite, i) => {
                                return <option key={i} value={companySite}>
                                    {companySite}
                                </option>
                            }) : null
                            }
                        </select>
                    </div>

                    <div>
                        <label htmlFor="compamy-status" >Account Status</label>: &nbsp;
                        <input
                            name="company-status"
                            type="radio"
                            value="Active"
                            defaultChecked={isActive}
                            onChange={(e) => {  setValues({ ...values, accountStatus: e.target.value }) }}
                        />Active

                        <input
                            name="company-status"
                            type="radio"
                            value="Inactive"
                            defaultChecked={!isActive}
                            onChange={(e) => {  setValues({ ...values, accountStatus: e.target.value }) }}
                        />Inactive
                    </div>



                    <div className="addresses">
                        <label htmlFor="address" >User Address </label>: &nbsp;
                        <div className="cardContainer">
                            <div onClick={openAddressModalHandler} className="addNewAddressCard">
                                <div
                                    className="addNewAddressText"

                                >
                                    + Add New Address
                                </div>
                            </div>

                            {values.address?.map((elem, index) => {
                                return (                            
                                    <div key={index}>
                                        <div className="card">
                                            <div className="addressContainer">
                                                <div className="name">{elem.firstName} {elem?.lastName}</div>
                                                <div className="address">
                                                    <div className="landMark">
                                                        {" "}
                                                        {elem?.addressLineOne},&nbsp;
                                                        {elem?.addressLineTwo}
                                                    </div>
                                                    <div className="state">{elem.city} {elem?.state} </div>
                                                    <div className="country">{elem?.country} {elem?.postalCode}</div>
                                                    <div className="mobile">
                                                     {elem?.phoneNo?  `Mobile: +${elem.dialCode}-${elem?.phoneNo}` : ""}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="addressButtons">
                                                <div className="btn" onClick={() => editHandler(index)} >Edit</div>
                                                <div className="btn" onClick={() => deleteData(index)}>Remove</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>


                    <div className="center-heading">
                        <button className="button-search" onClick={handleEditUser} style={{ marginTop: '15px' }}>  Update </button>
                    </div>


                    {
                        error ?
                            <div style={{ color: 'red', fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>{error}</div>
                            : null
                    }

                </div>
            </div>
        </div>
    )
}

export default EditUser;